import apiClient from './apiClient';

/**
 * Refunds service for handling refund-related API calls
 */
const refundsService = {
  /**
   * Create a refund for a transaction
   * @param {Object} refundData - Refund data
   * @param {string} refundData.transactionId - Transaction ID to refund
   * @param {number} refundData.amount - Amount to refund (optional, defaults to full amount)
   * @param {string} refundData.reason - Reason for refund
   * @param {string} refundData.externalReference - External reference (optional)
   * @returns {Promise} API response
   */
  createRefund: async (refundData) => {
    if (!refundData.transactionId) {
      throw new Error('Transaction ID is required');
    }
    
    if (!refundData.reason) {
      throw new Error('Refund reason is required');
    }
    
    const response = await apiClient.post('/refunds', refundData);
    return response.data;
  },

  /**
   * Void a pending transaction
   * @param {string} transactionId - Transaction ID to void
   * @param {string} reason - Reason for void
   * @returns {Promise} API response
   */
  voidTransaction: async (transactionId, reason) => {
    if (!transactionId) {
      throw new Error('Transaction ID is required');
    }
    
    if (!reason) {
      throw new Error('Void reason is required');
    }
    
    const response = await apiClient.post(`/refunds/${transactionId}/void`, {
      reason
    });
    return response.data;
  },

  /**
   * Get refund history for a user
   * @param {string} userId - User ID  
   * @returns {Promise} API response
   */
  getRefundHistory: async (userId) => {
    if (!userId) {
      throw new Error('User ID is required');
    }
    
    const response = await apiClient.get(`/refunds?userId=${userId}`);
    return response.data;
  },

  /**
   * Get refund details by ID
   * @param {string} refundId - Refund ID
   * @returns {Promise} API response  
   */
  getRefund: async (refundId) => {
    if (!refundId) {
      throw new Error('Refund ID is required');
    }
    
    const response = await apiClient.get(`/refunds/${refundId}`);
    return response.data;
  }
};

export default refundsService;